const home = {
  anJun: {
    zh: '安骏跨境物流系统',
    en: '',
    pu: 'Sistema Logístico Cross Border de Anjun'
  },
  welcomeAnJun: {
    zh: '欢迎使用安骏跨境物流系统',
    en: '',
    pu: 'Bem-vindo ao Sistema Logístico Cross Border de Anjun'
  },
  welcomeanjunKD: {
    zh: '欢迎使用安骏快递系统',
    en: '',
    pu: 'Bem-vindo ao Sistema Anjun Express'
  },
  brazilOrder: {
    zh: '巴西本地快递下单',
    en: '',
    pu: 'Fazer pedido por Express local do Brasil '
  },
  test: {
    zh: '请输入旧密码',
    en: '',
    pu: 'Favor digitar a senha antiga'
  },
  coverCountry: {
    zh: '覆盖巴西全国地区',
    en: '',
    pu: 'Cobrir todo o Brasil'
  },
  placeOrder: {
    zh: '立即下单',
    en: '',
    pu: 'Fazer pedido agora'
  },
  finalState: {
    zh: '最终状态',
    en: '',
    pu: 'Estado final'
  },
  failNode: {
    zh: '推送失败节点',
    en: '',
    pu: 'Nó de envio falhado'
  },
  inputFiller: {
    zh: '输入关键字进行过滤',
    en: '',
    pu: 'Digite palavras-chave para filtrar'
  },
  configInfo: {
    zh: '配置信息',
    en: '',
    pu: 'Informações de configuração'
  },
  initNumber: {
    zh: '初始数量',
    en: '',
    pu: 'Número inicial'
  },
  minlimitcount: {
    zh: '最小限制数',
    en: '',
    pu: 'Número mínimo de limites'
  },
  maxLimitcount: {
    zh: '最大限制数',
    en: '',
    pu: 'Limite máximo'
  },
  balanceCount: {
    zh: '结余总数量',
    en: '',
    pu: 'Saldo total'
  },
  tip01: {
    zh: '最小限制不能大于等于最大限制数',
    en: '',
    pu: 'O limite mínimo não pode ser maior ou igual ao limite máximo'
  },
  limitMaxNumber: {
    zh: '超过最大限制数',
    en: '',
    pu: 'Limite máximo excedido'
  },
  limitMinxNumber: {
    zh: '低于最小限制数',
    en: '',
    pu: 'Abaixo do limite mínimo'
  },
  returnToRegistration: {
    zh: '返回登记',
    en: '',
    pu: 'Retornar ao registro'
  },
  huiRegistration: {
    zh: '回收登记',
    en: '',
    pu: 'Registro de reciclagem'
  },
  urgeRecovery: {
    zh: '催回收',
    en: '',
    pu: 'Acelerar a recuperação de algo'
  },
  clickException: {
    zh: '异常调整',
    en: '',
    pu: 'Ajuste de exceção'
  },
  registerCount: {
    zh: '返回数量',
    en: '',
    pu: 'Número de devoluções'
  },
  homeCount: {
    zh: '数量',
    en: '',
    pu: 'Quantidades'
  },
  tip02: {
    zh: '说明：输入负数，减少结余总数量；输入正数，增加结余总数量',
    en: '',
    pu: 'Observação: digite um número negativo para diminuir o saldo total; digite um número positivo para aumentar o saldo total.'
  },
  operationTotal: {
    zh: '操作总数',
    en: '',
    pu: 'Número total de operações'
  },
  siteType: {
    zh: '网点类型',
    en: '',
    pu: 'Tipe de ponto'
  },
  tip03: {
    zh: '确认返回数量不能大于应返回数量',
    en: '',
    pu: 'Confirmação de que a quantidade devolvida não pode ser maior do que a quantidade a ser devolvida'
  },
  lijiReturn: {
    zh: '立即前往返回',
    en: '',
    pu: 'Voltar agora'
  },
  inputNumberdayu0: {
    zh: '输入大于零的整数',
    en: '',
    pu: 'Digite um número inteiro maior que zero'
  },
  uploadTime: {
    zh: '上传时间',
    en: '',
    pu: 'Tempo de carregamento'
  },
  applivefail: {
    zh: '审核失败',
    en: '',
    pu: 'Análise encerrada'
  },
  clickSee: {
    zh: '点击查看',
    en: '',
    pu: 'Visualizar'
  },
  qiangzhiApplive: {
    zh: '强制签收审核',
    en: '',
    pu: 'Auditoria de Pacotes'
  },
  seesingPhoto: {
    zh: '查看签收照片',
    en: '',
    pu: 'Ver fotografias assinadas'
  },
  ViewSignature: {
    zh: '查看签收签名',
    en: '',
    pu: 'Ver assinatura'
  },
  signedPhoto: {
    zh: '签收拍照',
    en: '',
    pu: 'Assinatura e fotografia'
  },
  signedNamePhoto: {
    zh: '签收签名',
    en: '',
    pu: 'Assinatura'
  },
  appliveResult: {
    zh: '审核结果',
    en: '',
    pu: 'Resultados da auditoria'
  },
  pass: {
    zh: '通过',
    en: '',
    pu: 'Aprovar'
  },
  noPass: {
    zh: '不通过',
    en: '',
    pu: 'Falhar'
  },
  unapplivefail: {
    zh: '审核未通过',
    en: '',
    pu: 'Análise reprovado'
  },
  photoStandard: {
    zh: '照片不合格',
    en: '',
    pu: 'Foto não conforme'
  },
  signStandard: {
    zh: '签名不合格',
    en: '',
    pu: 'Assinatura não conforme'
  },
  tip1002: {
    zh: '请选择不通过原因',
    en: '',
    pu: 'Por favor, selecione o motivo da não aprovação'
  },
  batchConfiguration: {
    zh: '批量配置',
    en: '',
    pu: 'Configuração em lote'
  },
  justSearchConditionCenter: {
    zh: '仅查询下属中心',
    en: '',
    pu: 'Query Only Subordinate Centers'
  },
  batchConfigurationSite: {
    zh: '仅查下属网点',
    en: '',
    pu: 'Query Only Subordinate Branches'
  },
  adjustSiteName: {
    zh: '被调整网点',
    en: '',
    pu: 'Agências Ajustadas'
  },
  adjustCount: {
    zh: '调整数量',
    en: '',
    pu: 'Ajustar Quantidade'
  },
  adjustReason: {
    zh: '调整原因',
    en: '',
    pu: 'Motivo do Ajuste'
  },
  adjustMan: {
    zh: '调整人',
    en: '',
    pu: 'Ajustador'
  },
  adjustTime: {
    zh: '调整日期',
    en: '',
    pu: 'Data do Ajuste'
  },
  vehicleNumber: {
    zh: '末端车牌号',
    en: '',
    pu: 'Número final de registo do veículo'
  },
  noPrintNumber: {
    zh: '没有需要打印的运单号',
    en: '',
    pu: 'Não há números de remessa que precisam ser impressos'
  },
  noOperator: {
    zh: '选择的订单状态不可操作',
    en: '',
    pu: 'O status do pedido selecionado não permite operações'
  },
  goodsNOfuhe: {
    zh: '商品与实际不符',
    en: '',
    pu: 'Os produtos não correspondem à realidade'
  },
  stopTime: {
    zh: '请选择截止时间',
    en: '',
    pu: 'Por favor, selecione a data limite'
  },
  infoError: {
    zh: '收件人信息错误,无法核实',
    en: '',
    pu: 'As informações do destinatário estão erradas e não podem ser verificadas'
  },
  fixTime: {
    zh: '修改截止时间',
    en: '',
    pu: 'Alterar prazo'
  },
  receiveMsgType: {
    zh: '消息接收类型',
    en: '',
    pu: 'Tipo de recepção de mensagens'
  },
  receiveMsgType00: {
    zh: '编织袋回收消息',
    en: '',
    pu: 'Mensagem de reciclagem de sacos tecidos'
  },
  notExport1000: {
    zh: '单次导出不能超过1000条数据',
    en: '',
    pu: 'A exportação única não pode exceder 1000 registros de dados'
  },
  exportPicture: {
    zh: '导出图片',
    en: '',
    pu: 'Exportar imagens'
  },
  UploadUser: {
    zh: '上传用户',
    en: 'Upload User',
    pu: 'Usuário de upload'
  },
  PaymentCertificate: {
    zh: '支付凭证',
    en: 'Payment Certificate',
    pu: 'Certificado de pagamento'
  },
  AnjunFinancialAuditDetails: {
    zh: '安骏财务审核详情',
    en: 'Anjun Financial Audit Details',
    pu: 'Detalhes da auditoria financeira do Anjun'
  },
  FinancialAudit: {
    zh: '财务审核',
    en: 'Financial Audit',
    pu: 'Auditoria financeira'
  },
  AuditUser: {
    zh: '审核用户',
    en: 'Audit User',
    pu: 'Usuário de auditoria'
  },
  AuditResultCannotBeEmpty: {
    zh: '审核结果不能为空',
    en: 'Audit result cannot be empty',
    pu: 'O resultado da auditoria não pode estar vazio'
  },
  PleaseConfirmThatThePayment: {
    zh: '请确认客户的支付金额与应付金额是否一致',
    en: 'Please confirm that the payment amount of the customer is consistent with the amount to be paid',
    pu: 'Por favor, confirme se o valor de pagamento do cliente é consistente com o valor a ser pago'
  },
  auditPassed: {
    zh: '支付金额一致，审核通过',
    en: 'Payment amount consistent, audit passed',
    pu: 'O valor de pagamento é consistente, auditoria passada'
  },
  auditNotPassed: {
    zh: '支付金额不一致，审核不通过',
    en: 'Payment amount inconsistent, audit not passed',
    pu: 'O valor de pagamento é inconsistente, auditoria não passada'
  },
  AuditRemarkCannotBeEmpty: {
    zh: '审核备注不能为空',
    en: 'Audit remark cannot be empty',
    pu: 'As observações de auditoria não podem estar vazias'
  },
  PleaseEnterARemark: {
    zh: '请输入备注',
    en: 'Please enter a remark',
    pu: 'Por favor, insira uma observação'
  },
  fixResult: {
    zh: '修改状态或结果',
    en: '',
    pu: 'Alterar status ou resultado'
  },
  moreTimeNotReply: {
    zh: '超时未回复',
    en: '',
    pu: 'Nenhuma resposta devido ao tempo limite'
  },
  ScanninTip0313: {
    zh: '该功能用于盘点滞留在网点的包裹以产生新的轨迹',
    en: 'This feature is used to inventory packages滞留 at the branch to generate new tracking events',
    pu: 'Este recurso serve para inventariar pacotes retidos na agência e gerar novos eventos de rastreamento'
  },
  scanWaybillOrBagNumber: {
    zh: '扫描运单号或袋号',
    en: 'Scan Waybill or Bag Number',
    pu: 'Escanear Número de Rastreamento ou Número da Sacola'
  },
  lastScannedTrackingOrBag: {
    zh: '最新扫描运单号或袋号',
    en: 'Last Scanned Tracking/Bag Number',
    pu: 'Último Número de Rastreamento/Sacola Escaneado'
  },
  inputOrScanner: {
    zh: '请扫描或输入',
    en: '',
    pu: 'Favor digitalizar ou digitar'
  },
  storagePartsScanning: {
    zh: '移除出袋',
    en: 'Remove the bag',
    pu: 'Retire o saco'
  },
  advancedSearch: {
    zh: '高级搜索',
    en: 'Advanced Search',
    pu: 'Mais filtros'
  },
  selectDropdownData: {
    zh: '请选择下拉框数据',
    en: 'Please select dropdown data',
    pu: 'Por favor selecione os dados do menu suspenso'
  },
  selectSameComplaintType: {
    zh: '请选择相同的投诉类型',
    en: 'Please select the same complaint type',
    pu: 'Por favor selecione o mesmo tipo de reclamação'
  },
  modifyStatus: {
    zh: '修改状态',
    en: 'Modify Status',
    pu: 'Modificar Status'
  },
  modifyResult: {
    zh: '修改结果',
    en: 'Modify Result',
    pu: 'Modificar Resultado'
  },
  onDutyRegistration: {
    zh: '上岗人数登记',
    en: 'On-Duty Personnel Registration',
    pu: 'Registro de Pessoal em Serviço'
  },
  position: {
    zh: '岗位',
    en: 'Position',
    pu: 'Cargo/Função'
  },
  onDutyDate: {
    zh: '上岗日期',
    en: 'On-Duty Date',
    pu: 'Data de Início no Serviço'
  },
  onDutyCount: {
    zh: '上岗人数',
    en: 'Number of On-Duty Personnel',
    pu: 'Número de Pessoal em Serviço'
  },
  enterValidNumber: {
    zh: '请输入有效的数字',
    en: 'Please enter a valid number',
    pu: 'Por favor insira um número válido'
  },
  selectPosition: {
    zh: '选择岗位',
    en: 'Select Position',
    pu: 'Selecionar Cargo'
  },
  collection: {
    zh: '揽收',
    en: 'Collection',
    pu: 'Coleta'
  },
  sorting: {
    zh: '分拣',
    en: 'Sorting',
    pu: 'Triagem'
  },
  transportation: {
    zh: '运输',
    en: 'Transportation',
    pu: 'Transporte'
  },
  funcFavorites: {
    zh: '功能收藏夹',
    en: 'Function Favorites',
    pu: 'Funcionalidades favoritos'
  },
  selectMenu: {
    zh: '选择菜单',
    en: 'Select Menu',
    pu: 'Selecionar Menu'
  },
  setFavorites: {
    zh: '设置收藏夹',
    en: 'Set Favorites',
    pu: 'Configurar Favoritos'
  },
  pinToTop: {
    zh: '置顶',
    en: 'Pin to Top',
    pu: 'Fixar no Topo'
  },
  batchReview: {
    zh: '批量审核',
    en: 'Batch Review',
    pu: 'Revisão em Lote'
  },
  reviewResult: {
    zh: '审核结果',
    en: 'Review Result',
    pu: 'Resultado da Revisão'
  },
  returnInflowHub: {
    zh: '返还/流入网点',
    en: 'Return/Inflow Hub',
    pu: 'Centro de Devolução/Entrada'
  },
  recycleOutflowHub: {
    zh: '回收/流出网点',
    en: 'Recycle/Outflow Hub',
    pu: 'Centro de Reciclagem/Saída'
  },
  returnDataQuery: {
    zh: '返回数据查询',
    en: 'Return Data Query',
    pu: 'Consulta de Dados de Devolução'
  },
  recycleDataQuery: {
    zh: '回收数据查询',
    en: 'Recycle Data Query',
    pu: 'Consulta de Dados de Reciclagem'
  },
  inflowSummary: {
    zh: '流入汇总',
    en: 'Inflow Summary',
    pu: 'Resumo de Entrada'
  },
  outflowSummary: {
    zh: '流出汇总',
    en: 'Outflow Summary',
    pu: 'Resumo de Saída'
  },
  returnStatus: {
    zh: '返还状态',
    en: 'Return Status',
    pu: 'Status de Devolução'
  },
  recycled: {
    zh: '已回收',
    en: 'Recycled',
    pu: 'Reciclado'
  },
  notRecycledTotal: {
    zh: '未回收总数',
    en: 'Not Recycled Total',
    pu: 'Total Não Reciclado'
  },
  notRecycled: {
    zh: '未回收',
    en: 'Not Recycled',
    pu: 'Não Reciclado'
  },
  pendingConfirmation: {
    zh: '待确认',
    en: 'Pending Confirmation',
    pu: 'Pendente'
  },
  returned: {
    zh: '已返还',
    en: 'Returned',
    pu: 'Devolvido'
  },
  notReturned: {
    zh: '未返还',
    en: 'Not Returned',
    pu: 'Não Devolvido'
  },
  notReturnedTotal: {
    zh: '未返还总数',
    en: 'Not Returned Total',
    pu: 'Total Não Devolvido'
  },
  greaterThanZeroMax999: {
    zh: '输入大于0, 最大999',
    en: 'Enter a number greater than 0, maximum 999',
    pu: 'Insira um número maior que 0, máximo 999'
  },
  keepThreeDecimals: {
    zh: '保留三位小数',
    en: 'Keep three decimal places',
    pu: 'Manter três casas decimais'
  },
  greaterThanZeroMax500: {
    zh: '输入大于0, 最大500',
    en: 'Enter a number greater than 0, maximum 500',
    pu: 'Insira um número maior que 0, máximo 500'
  },
  trackingNode: {
    zh: '轨迹节点',
    en: 'Tracking Node',
    pu: 'Nó de Rastreamento'
  },
  trackingNodeCode: {
    zh: '轨迹节点代码',
    en: 'Tracking Node Code',
    pu: 'Código do Nó de Rastreamento'
  },
  numericCode: {
    zh: '数字代码',
    en: 'Numeric Code',
    pu: 'Código Numérico'
  },
  chineseDescription: {
    zh: '中文描述',
    en: 'Chinese Description',
    pu: 'Descrição em Chinês'
  },
  portugueseDescription: {
    zh: '葡语描述',
    en: 'Portuguese Description',
    pu: 'Descrição em Português'
  },
  isPublic: {
    zh: '是否对外',
    en: 'Is Public',
    pu: 'É Público'
  },
  publicChineseDescription: {
    zh: '对外-中文描述',
    en: 'Public Chinese Description',
    pu: 'Descrição Pública em Chinês'
  },
  publicPortugueseDescription: {
    zh: '对外-葡语描述',
    en: 'Public Portuguese Description',
    pu: 'Descrição Pública em Português'
  },
  AddHoliday: {
    zh: '新增节假日',
    en: 'Add Holiday',
    pu: 'Adicionar Feriado'
  },
  HolidayName: {
    zh: '假期名称',
    en: 'Holiday Name',
    pu: 'Nome do feriado'
  },
  Days: {
    zh: '天数',
    en: 'Days',
    pu: 'Dias'
  },
  HolidayType: {
    zh: '假期类型',
    en: 'Holiday Type',
    pu: 'Tipo de feriado'
  },
  StateOrCity: {
    zh: '州或城市',
    en: 'State or City',
    pu: 'Estado ou cidade'
  },
  LatestModificationTime: {
    zh: '最新修改时间',
    en: 'Latest Modification Time',
    pu: 'Última alteração por'
  },
  LatestModifier: {
    zh: '最新修改人',
    en: 'Latest Modifier',
    pu: 'Última atualização'
  },
  serialNumber: {
    zh: '序号',
    en: 'number',
    pu: 'Número'
  },
  EditHoliday: {
    zh: '编辑节假日',
    en: 'Edit Holiday',
    pu: 'Editar feriado'
  },
  SelectStateCity: {
    zh: '选择州或城市',
    en: 'Select State or City',
    pu: 'Selecionar Estado ou Cidade'
  },
  SelectMerchant: {
    zh: '选择商户',
    en: 'Select Merchant',
    pu: 'Selecionar Comerciante'
  },
  NationalHoliday: {
    zh: '全国假期',
    en: 'National Holiday',
    pu: 'Feriado Nacional'
  },
  LocalHoliday: {
    zh: '地方假期',
    en: 'Local Holiday',
    pu: 'Feriado Local'
  },
  RefreshHistoricalData: {
    zh: '刷新历史数据',
    en: 'Refresh Historical Data',
    pu: 'Atualizar Dados Históricos'
  },
  nfeInvoiceNumber: {
    zh: 'NFE发票号',
    en: 'NFE Invoice Number',
    pu: 'Número da Nota Fiscal NFE'
  },
  nfeInvoiceKey: {
    zh: 'NFE发票密钥',
    en: 'NFE Invoice Key',
    pu: 'Chave da Nota Fiscal NFE'
  },
  timeRangeLimit7Days: {
    zh: '时间范围不能超过7天，请重新选择！',
    en: 'Time range cannot exceed 7 days, please select again!',
    pu: 'O intervalo de tempo não pode exceder 7 dias, por favor selecione novamente!'
  },
  max20: {
    zh: '最多20个',
    en: 'Maximum 20',
    pu: 'Máximo 20'
  }
};
export { home };
